export default "__VITE_ASSET__C3u7PXea__"